var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiBase } from '@common/api/apiBase';
import { httpClientApiSchool } from '@common/utils/HttpClient';
var PromoCodeApi = /** @class */ (function (_super) {
    __extends(PromoCodeApi, _super);
    function PromoCodeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Получить список промокодов школы
     *
     * @returns {Promise<AxiosResponse<GetResponse<GetPromoCodeListDto>>>}
     */
    PromoCodeApi.prototype.getPromoCodeList = function () {
        return httpClientApiSchool.get("discount/list");
    };
    /**
     * Создать промокод
     *
     * @param {GetRequest<CreatePromoCodeDto>} data
     * @returns {Promise<AxiosResponse<GetResponse<CreatePromoCodeDto>>>}
     */
    PromoCodeApi.prototype.createPromoCode = function (data) {
        return httpClientApiSchool.post("discount/create", data);
    };
    /**
     * Обновить промокод
     *
     * @param {string} discountUuid
     * @param {GetRequest<UpdatePromoCodeDto>} data
     * @returns {Promise<AxiosResponse<GetResponse<UpdatePromoCodeDto>>>}
     */
    PromoCodeApi.prototype.updatePromoCode = function (discountUuid, data) {
        return httpClientApiSchool.post("discount/".concat(discountUuid, "/update"), data);
    };
    /**
     * удалить промокод
     *
     * @param {string} discountUuid
     * @returns {Promise<AxiosResponse<GetResponse<RemovePromoCodeDto>>>}
     */
    PromoCodeApi.prototype.removePromoCode = function (discountUuid) {
        return httpClientApiSchool.delete("discount/".concat(discountUuid, "/remove"));
    };
    return PromoCodeApi;
}(ApiBase));
export default new PromoCodeApi();
